<mat-toolbar class="mat-elevation-z6 bg-card">
  <mat-toolbar-row *ngIf="notificationTemplate" color="primary" class="bg-primary" [ngClass]="notificationRowClass">
    <template [ngTemplateOutlet]="notificationTemplate"></template>
  </mat-toolbar-row>
  <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
    <ng-content></ng-content>
  </mat-toolbar-row>

</mat-toolbar>
